<elcia-card>
  <div class="flex flex-col gap-4">
    <!-- Section header -->
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2.5">
        <!-- Server icon via PrimeNG pi class — purely decorative -->
        <span class="pi pi-server text-surface-400 text-sm" aria-hidden="true"></span>
        <span class="text-lg font-bold">{{ 'licence-server.title' | translate }}</span>
        <span class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2.5 tabular-nums">
          {{ licenceServers().length }}
        </span>
      </div>
      <elcia-button (onClick)="showForm()" [icon]="'plus'" [label]="'action.add-licence-server' | translate"/>
    </div>

    @if (licenceServers().length === 0) {
      <!-- Empty state -->
      <div class="flex flex-col items-center justify-center gap-2 py-10 text-surface-400">
        <span class="pi pi-inbox text-2xl opacity-40" aria-hidden="true"></span>
        <span class="text-sm">{{ 'licence-server.empty' | translate }}</span>
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        @for (server of licenceServers(); track server.id) {
          <elcia-licence-server-item
            (onDelete)="deleteServer($event)"
            (onEdit)="openEditForm($event)"
            (onGenerateCredentials)="onGenerateCredentials($event)"
            [isGeneratingCredentials]="isGenerating(server.id)"
            [server]="server"/>
        }
      </div>
    }
  </div>
</elcia-card>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    [isActionLoading]="isSaving()"
    [mustDisplayDeleteButton]="false"
    [size]="'small'"
    [title]="(openMode() === 'edit' ? 'licence-server.edit' : 'licence-server.add') | translate">
    <elcia-licence-server-dialog
      (onSubmit)="onFormSubmit($event)"
      [customerId]="customerId() ?? null"
      [initialValue]="selectedServer()"/>
  </elcia-dialog>
}

@if (pendingCredentialsServer(); as server) {
  <elcia-dialog
    (onAction)="confirmGenerateCredentials()"
    (onClose)="cancelGenerateCredentials()"
    [actionIcon]="'lock'"
    [actionLabel]="'licence-server.generate-credentials'"
    [isActionLoading]="isGeneratingCredentials()"
    [size]="'x-small'"
    [title]="'licence-server.generate-credentials' | translate">
    <div class="font-medium">
      {{ 'licence-server.generate-credentials-confirm' | translate }}
    </div>
    <br>
    <div class="font-medium wrap-break-word">{{ server.name }}</div>
  </elcia-dialog>
}

@if (credentials(); as generatedCredentials) {
  <elcia-dialog
    (onClose)="closeCredentials()"
    [mustDisplayActionButton]="false"
    [size]="'small'"
    [title]="'licence-server.credentials-title' | translate">
    <elcia-licence-server-credentials-dialog [credentials]="generatedCredentials"/>
  </elcia-dialog>
}

<elcia-confirm-dialog/>
